var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 16,
    viewBox: "0 0 151 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.712 8.70238C151.1 8.30926 151.095 7.67611 150.702 7.2882L144.296 0.966801C143.903 0.578889 143.27 0.58311 142.882 0.976229C142.494 1.36935 142.498 2.0025 142.891 2.39041L148.586 8.00943L142.967 13.7039C142.579 14.097 142.583 14.7301 142.976 15.1181C143.369 15.506 144.002 15.5017 144.39 15.1086L150.712 8.70238ZM0.00666652 9.99998L150.007 8.99998L149.993 7.00002L-0.00666652 8.00002L0.00666652 9.99998Z",
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.54d5e896f51ab64bce6191fae301afdf.svg";
export { ForwardRef as ReactComponent };